import type { SupSingleVaultV3 } from "@/types";
import { useCallback } from "react";

import { useStoredDataDispatch } from "@/store";
import useTokenBalances from "@/hooks/api/useTokenBalances";
import { FixedNumber } from "@ethersproject/bignumber";

export default function useApeIn(singleVault: SupSingleVaultV3) {
  const storedDispatch = useStoredDataDispatch();
  const { data: balance } = useTokenBalances(true, "default");

  return useCallback(() => {
    storedDispatch({ type: "clearCart" });
    storedDispatch({ vault: singleVault, type: "toggleCart" });
    if (balance) {
      const biggestBalance = balance.sort((a, b) => parseFloat(b.amountInFiat ?? "0") - parseFloat(a.amountInFiat ?? "0"))[0];
      if (biggestBalance) {
        storedDispatch({
          type: "setTxCartValue",
          txCartValue: {
            cart: "deposit",
            selectedBalance: biggestBalance,
            totalAmount: FixedNumber.from(biggestBalance.amount).divUnsafe(FixedNumber.from("2")).toString(),
          },
        });
      }
    } else {
      storedDispatch({
        type: "setTxCartValue",
        txCartValue: undefined,
      });
    }
    storedDispatch({ overlay: "deposit", type: "setOverlay" });
  }, [balance, singleVault, storedDispatch]);
}
